const formData = {
  formId: "cognitoUserForm",
  formField: {
    name: {
      name: "name",
      label: "Name",
      requiredErrorMessage: "Name is required.",
    },
    dateOfBirth: {
      name: "dateOfBirth",
      label: "Date Of Birth",
      requiredErrorMessage: "Date Of Birth is required.",
    },
  },
};

export default formData;
